module.exports = __webpack_public_path__ + "static/elm-e9dd01b09ae0fe67cd06d8f220f95289.jpg";